export enum ButtonTypes {
  Accent = 'accent',
  Primary = 'primary',
  Secondary = 'secondary',
  Outlined = 'outlined',
  OutlinedGray = 'outlined-gray',
  Critical = 'critical',
  Inversion = 'inversion',
  Unset = 'unset',
}

export enum ButtonSizes {
  L = 'l',
  M = 'm',
  S = 's',
  XS = 'xs',
  Unset = 'unset',
}

export enum ButtonRadiuses {
  L = 'l',
  M = 'm',
  S = 's',
  Unset = 'unset',
}
